export { default } from './Hero';



// WEBPACK FOOTER //
// ./src/components/templates/Hero/index.js